import React from "react";

const Collaborate: React.FC = () => {
  return (
    <svg
      width="58"
      height="60"
      viewBox="0 0 58 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 444">
        <rect
          id="Rectangle 798"
          x="8"
          y="10"
          width="50"
          height="50"
          rx="6"
          fill="url(#paint0_linear_9793_15609)"
        />
        <g
          id="Rectangle 797"
          style={{ mixBlendMode: "multiply" }}
          opacity="0.6"
        >
          <rect
            width="47"
            height="47"
            rx="6"
            fill="url(#paint1_linear_9793_15609)"
          />
        </g>
        <path
          id="Vector"
          d="M33.7959 21.5545C33.3388 21.0601 32.7883 20.6627 32.178 20.3867C31.5696 20.1115 30.9136 19.9661 30.2522 19.96C29.5905 19.9511 28.937 20.0781 28.3317 20.3332C27.7264 20.5883 27.1819 20.9662 26.7316 21.4436L25.9818 22.2303L25.3517 21.6271C23.3984 19.7281 20.31 19.6001 18.4773 21.3538C17.9995 21.807 17.6204 22.3553 17.3631 22.9655C17.1058 23.5756 16.9756 24.2348 16.9804 24.9031C16.9853 25.5714 17.1251 26.2348 17.3913 26.853C17.6575 27.4713 18.0446 28.0314 18.5291 28.4996L25.4867 35.2344C25.6121 35.3529 25.7572 35.4481 25.915 35.5153C26.0746 35.5782 26.2439 35.6103 26.4139 35.61C26.7593 35.6039 27.0849 35.4599 27.3193 35.2098L33.668 28.4877C35.5143 26.5685 35.5604 23.4487 33.7959 21.5545Z"
          fill="#071443"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9793_15609"
          x1="68.3266"
          y1="88.2613"
          x2="31.3698"
          y2="33.3695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEE8CD" />
          <stop offset="1" stopColor="#FFDED2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9793_15609"
          x1="66.5"
          y1="91"
          x2="7.99653"
          y2="11.7282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA72CB" />
          <stop offset="1" stopColor="#FFC4B1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Collaborate;
